import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SearchResult, Settings, TechnicalService } from 'src/app/interfaces';
import { SettingsService } from 'src/app/services';
import { SearchResultComponent } from 'src/app/components/search-result/search-result.component';
import { ActivatedRoute } from '@angular/router';
/**
 * Search Panel and Map components
 *
 * @export
 * @class StaLocatorComponent
 */
@Component({
  selector: 'app-sta-locator',
  templateUrl: './sta-locator.component.html',
  styleUrls: ['./sta-locator.component.scss'],
})
export class StaLocatorComponent implements OnInit {
  /**
   * Search result instance
   *
   * @type {SearchResultComponent}
   * @memberof StaLocatorComponent
   */
  @ViewChild('searchResult', {
    read: false,
    static: false,
  })
  searchResultRef: SearchResultComponent;

  /**
   * Flag to toggle search panel visibility
   *
   * @type {boolean}
   * @memberof StaLocatorComponent
   */
  showPanel: boolean = true;

  /**
   * Results found
   *
   * @type {SearchResult}
   * @memberof StaLocatorComponent
   */
  results: SearchResult;
  /**
   * Brand settings
   *
   * @type {Settings}
   * @memberof StaLocatorComponent
   */
  settings: Settings;

  /**
   * Flag to toggle search panel visibility
   *
   * @type {boolean}
   * @memberof StaLocatorComponent
   */
  isCallcenter: boolean = false;

  /**
   *  Creates an instance of StaLocatorComponent.
   * @param {SettingsService} settingsService
   * @memberof StaLocatorComponent
   */
  constructor(private settingsService: SettingsService, private route: ActivatedRoute) {}

  /**
   * Retrieves brand settings
   *
   * @memberof StaLocatorComponent
   */
  async ngOnInit() {
    this.settings = await this.settingsService.getSettings();
    this.isCallcenter = this.route.snapshot.data[0] === 'sta-locator-callcenter';
  }

  /**
   * Show the technical services found and the selected category
   *
   * @param {TechnicalService[]} technicalServices
   * @memberof StaLocatorComponent
   */
  showSearchResults(_result: SearchResult) {
    if(_result.subCategory != undefined){
      if(_result.subCategory.visitaDomicilio === false){
        _result.technicalServices.forEach(x=>{
          x.puedeRetirar = false;
        })
      }
    }else{
      if(_result.category.visitaDomicilio === false){
        _result.technicalServices.forEach(x=>{
          x.puedeRetirar = false;
        })
      }
    }
    this.results = _result;

    this.toggleSearchPanel(false);
  }

  /**
   * Toggle search panel visibility
   *
   * @param {boolean} isVisible
   * @memberof StaLocatorComponent
   */
  toggleSearchPanel(isVisible: boolean) {
    this.showPanel = isVisible;
  }

  /**
   * Show detail of technical service when the user clicks on the marker
   *
   * @param {TechnicalService} technicalService
   * @memberof StaLocatorComponent
   */
  onMarkerClicked(technicalService: TechnicalService) {
    this.searchResultRef && this.searchResultRef.showItemDetail(technicalService);
  }
}
